<template>
	<section
		class="border-t border-[#1F1F1F] bg-black px-6 pt-14 pb-16 text-[13px] leading-[1.7] text-[#A8A8A8]"
	>
		<div class="mx-auto flex max-w-[1240px] flex-col gap-5">
			<p class="m-0 max-w-[980px]">
				Simulações ilustrativas, com taxas de referência de mercado. Não incluem
				seguros (MIP e DFI), TR, IOF, taxa de avaliação, tarifas nem reajustes.
				Taxas, prazos e aprovação dependem da análise de crédito de cada
				instituição financeira ou administradora de consórcio.
			</p>
		</div>
	</section>
</template>
